import script from "./MapLegendsBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./MapLegendsBlock.vue?vue&type=script&setup=true&lang=js"

import "./MapLegendsBlock.vue?vue&type=style&index=0&id=51153aa9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51153aa9"]])

export default __exports__